import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  achieved: {
    backgroundColor: theme.palette.success.main,
    color: theme.palette.common.white,
  },
  failed: {
    backgroundColor: theme.palette.pinkMagenta,
    color: theme.palette.common.white,
  },
  pending: {
    backgroundColor: theme.palette.warning.main,
    color: theme.palette.common.white,
  },
  overdue: {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.common.white,
  },
}))

export default useStyles
